"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.referrals = void 0;
var createUser_1 = require("./createUser");
var getPoolLeaders_1 = require("./getPoolLeaders");
var getSwapLeaders_1 = require("./getSwapLeaders");
var getUser_1 = require("./getUser");
var updateUser_1 = require("./updateUser");
exports.default = {
    createUser: createUser_1.createUser,
    getPoolLeaders: getPoolLeaders_1.getPoolLeaders,
    getSwapLeaders: getSwapLeaders_1.getSwapLeaders,
    getUser: getUser_1.getUser,
    updateUser: updateUser_1.updateUser,
};
exports.referrals = {
    createUser: createUser_1.createUser,
    getPoolLeaders: getPoolLeaders_1.getPoolLeaders,
    getSwapLeaders: getSwapLeaders_1.getSwapLeaders,
    getUser: getUser_1.getUser,
    updateUser: updateUser_1.updateUser,
};
